import { render } from "./Bedrock.vue?vue&type=template&id=3394c0d8&ts=true"
import script from "./Bedrock.vue?vue&type=script&lang=ts"
export * from "./Bedrock.vue?vue&type=script&lang=ts"

import "./Bedrock.vue?vue&type=style&index=0&id=3394c0d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__